import { CreativeCardSkeleton } from "./CreativeCardSkeleton";

interface CreativesGridSkeletonProps {
  count?: number;
}

export function CreativesGridSkeleton({
  count = 6,
}: CreativesGridSkeletonProps) {
  return (
    <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {Array.from({ length: count }).map((_, idx) => (
        <CreativeCardSkeleton key={idx} />
      ))}
    </div>
  );
}

